import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-v2',
  templateUrl: './footer-v2.component.html',
  styleUrls: ['./footer-v2.component.scss', '/src/assets/css/common-v2/main-custom.scss']
})
export class FooterV2Component {
  currentYear = new Date();
}
